import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/pt';
import { PiRocket } from 'react-icons/pi';
import { FiStar } from 'react-icons/fi';
import { PATHS } from '@/routes/paths';
import { cn } from '@/lib/utils';
import { useNextLiveClass } from './use-next-live-class';
import liveScreenIcon from '@/assets/images/icons/live-screen.png';

function formatHour(momentDate) {
  return momentDate.minutes() === 0 ? momentDate.format('H[h]') : momentDate.format('H[h]mm');
}

// O ícone fica fora do grupo texto+botão (só ao lado do topo do texto) — o
// botão "Horários" é irmão do bloco de texto, não da linha ícone+texto, então
// ele fica alinhado embaixo das INFORMAÇÕES (mesmo recuo do texto), não
// embaixo do ícone. justify-between: a linha 1 do grid do hero estica os dois
// cards pra mesma altura (ver dashboard-teacher-hero.jsx); sem isso o botão
// ficava colado no texto e sobrava um vão vazio no fim do card mais alto.
export function NextClassBanner({ className }) {
  const { t } = useTranslation();
  moment.locale(t('language.language'));

  const { nextLiveClass, loading } = useNextLiveClass();

  if (loading || !nextLiveClass) {
    return null;
  }

  const startDateTime = moment(nextLiveClass['initial-date']);
  const endDateTime = moment(nextLiveClass['end-date']);
  const courseNames = (nextLiveClass.courses || [])
    .map(course => course.name)
    .filter(Boolean)
    .join(', ');

  return (
    <div className={cn('bg-success-lighter relative flex items-start gap-4 overflow-hidden rounded-[24px] p-4 shadow-card sm:p-6', className)}>
      <PiRocket
        aria-hidden="true"
        className="pointer-events-none absolute right-6 top-6 h-9 w-9 text-[#0A5C36]/30"
      />
      <FiStar
        aria-hidden="true"
        className="pointer-events-none absolute bottom-6 right-16 h-7 w-7 text-[#0A5C36]/25"
      />

      <img
        src={liveScreenIcon}
        alt=""
        aria-hidden="true"
        className="hidden h-20 w-20 shrink-0 object-contain drop-shadow-sm sm:block"
      />

      <div className="flex h-full flex-col items-start justify-between gap-4">
        <div className="flex flex-col items-start gap-1">
          <p
            className="text-sm"
            style={{ color: '#222731' }}
          >{`Próxima aula · ${startDateTime.format('dddd')}, ${startDateTime.format('DD/MM')} ${formatHour(startDateTime)} às ${formatHour(endDateTime)}`}</p>
          <p
            className="text-2xl font-black leading-tight sm:text-3xl"
            style={{ color: '#222731' }}
          >
            {nextLiveClass.title}
          </p>
          {courseNames && <p className="mt-4 text-sm font-semibold text-neutral-600">{courseNames}</p>}
        </div>

        <Link
          to={PATHS.LIVE_CLASSES.LIST}
          className="relative flex h-9 shrink-0 items-center justify-center rounded-full px-4 text-sm font-bold text-white transition-transform duration-100 active:scale-[0.97]"
          style={{
            background: 'var(--color-mission-light)',
            boxShadow: '0 3px 0 color-mix(in srgb, var(--color-mission-light) 72%, #000), 0 4px 8px rgba(0,0,0,0.18)'
          }}
        >
          Horários
        </Link>
      </div>
    </div>
  );
}
